import { render, staticRenderFns } from "./MarketingSmsFormContent.vue?vue&type=template&id=13bce53d&scoped=true"
import script from "./MarketingSmsFormContent.vue?vue&type=script&lang=js"
export * from "./MarketingSmsFormContent.vue?vue&type=script&lang=js"
import style0 from "./MarketingSmsFormContent.vue?vue&type=style&index=0&id=13bce53d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bce53d",
  null
  
)

export default component.exports